/* eslint-disable no-mixed-operators */

/*
Capabilities:
- CAP-PROMOTION-PARTICIPATION

Responsibilities:
- Render the Capture-the-Moments promotion modal, prepare image uploads, and
- reflect campaign progress/result state back into the member UI.

Context:
- project-intelligence/capabilities/requested/member/promotion-participation.md
*/

import React, { useState, useRef, useEffect } from 'react';

import moment from 'moment-timezone';

import Modal from 'react-bootstrap/Modal';
import CloseButton from 'react-bootstrap/CloseButton';

import RESTUtils from '../../../utils/rest-utils';

import { VerticalSeparator } from '../utils';

import { isDev } from '../../../utils/general-utils';

import html2canvas from 'html2canvas';
import { readAndCompressImage } from 'browser-image-resizer';

const PROMO_IMAGE = 'capture-the-moments-2025-promo-button.png';

const CTM_MAIN_WIDTH = 1200;
const CTM_MAIN_HEIGHT = 2804;
const CTM_SLOT_WIDTH = 330;
const CTM_MAIN_IMAGE_FILENAME = 'capture-the-moments-2025-top.png';
const CTM_BG_IMAGE_FILENAME = 'capture-the-moments-2025-top-bg.png';
const CTM_ONGOING_FOOTER_ONGOING_FILENAME = 'capture-the-moments-2025-bottom-rules-2.png';
const CTM_COMPLETE_FOOTER_FILENAME = 'capture-the-moments-2025-bottom-congrats.png';

const CTM_UPLOAD_BUTTON_IMAGE_FILENAME = 'capture-the-moments-2025-upload-button.png';
const CTM_UPLOAD_BUTTON_WIDTH = 688 * 0.6;
const CTM_UPLOAD_BUTTON_HEIGHT = 583 * 0.6;
const CTM_UPLOAD_BUTTON_Y_POS = 2400;
const CTM_UPLOAD_BUTTON_X_POS = 750;

const CTM_TERMS_AND_CONDITIONS_FILENAME = 'capture-the-moments-2025-bottom-rules-terms.png';
// const CTM_TERMS_AND_CONDITIONS_Y_POS = 1000;
const CTM_TERMS_AND_CONDITIONS_Y_POS = 2140;
const CTM_TERMS_AND_CONDITIONS_URL = 'https://swensens.com.sg/capture-the-moments-challenge/';

const CTM_POPUP_DURATION_IN_MS = 8000;
const CTM_POPUP_FILENAMES = {
    TRANSACTION_NEEDED: 'capture-the-moments-2025-popup-transaction-needed.png',
    UPLOAD_VALIDATED: 'capture-the-moments-2025-popup-upload-validated.png',
    DECLINED: 'capture-the-moments-2025-popup-upload-declined.png',
    UPLOAD_VALIDATED_4: 'capture-the-moments-2025-popup-upload-validated-img4.png',
    COMPLETED: 'capture-the-moments-2025-popup-upload-validated.png',
}

const CTM_SLOTS = [
    { zIndex: 22, rot: -7.61, x: 89, y: 1189 },
    { zIndex: 23, rot: 3.81, x: 453, y: 1271 },
    { zIndex: 21, rot: -9.98, x: 793, y: 1320 },
    { zIndex: 24, rot: 2.01, x: 99, y: 1787 },
    { zIndex: 25, rot: -5.1, x: 437, y: 1881 },
    { zIndex: 26, rot: 10.48, x: 867, y: 1771 },
    { zIndex: 27, rot: -7.61, x: 109, y: 2330 },
]

const PROMO_CYCLE_LENGTH = 273;
const PROMO_INTER_CYCLE_WAIT = 365 - 213;

const CLOSE_BUTTON_VARIANT = null;  // 'white';

const CACHE_BREAKER_IN_DEV = isDev ? `?s=${encodeURIComponent((new Date()).toISOString().split(':')[0])}` : '';

function getStartingAddenda(memberData) {
    const relevantAddenda = memberData.__addenda__.filter(a => a.key.startsWith('campaign:moments-2025:content:'));
    // const startingAddenda = relevantAddenda.filter(a => a.key.endsWith('1') && a.data.validated).sort((a1, a2) => Number(a2.key.split(':')[3]) - Number(a1.key.split(':')[3]));
    const startingAddenda = relevantAddenda.filter(a => a.key.endsWith('1')).sort((a1, a2) => Number(a2.key.split(':')[3]) - Number(a1.key.split(':')[3]));
    return startingAddenda;
}

function getCycleEndTime(last_cycle_start_ts_iso) {
    return new Date(new Date(last_cycle_start_ts_iso.split('T')[0] + 'T00:00:00+08:00').getTime() + (PROMO_CYCLE_LENGTH + 1) * 24 * 60 * 60 * 1000 - 1)
}

function getNextCycleStartTime(last_cycle_start_ts_iso) {
    return new Date(new Date(last_cycle_start_ts_iso.split('T')[0] + 'T00:00:00+08:00').getTime() + (PROMO_CYCLE_LENGTH + PROMO_INTER_CYCLE_WAIT) * 24 * 60 * 60 * 1000)
}

export default function CaptureTheMoments({
    showModal, setShowModal,
    token, memberData, updateMemberData
}) {
    /*
    CAP-PROMOTION-PARTICIPATION entry point for member-content upload.

    Notable frontend behavior:
    - compresses selected images into `small` and `large` variants,
    - posts multipart form data with the current member token,
    - refreshes member data and derives popup state from the returned addendum.
    */
    // const [frontBackToggle, setFrontBackToggle] = useState(false);

    const [uploadInProgress, setUploadInProgress] = useState(false);
    const [completeBasedOnRecentUpload, setCompleteBasedOnRecentUpload] = useState(false);
    const [showPopupType, setShowPopupType] = useState(null);

    const containerRef = useRef(null);
    const [containerWidth, setContainerWidth] = useState(0);
    const scaleFactor = containerWidth > 0 ? (containerWidth / CTM_MAIN_WIDTH) : 1;

    console.log(`containerWidth=${containerWidth}px\nscaleFactor=${scaleFactor}px`);

    const startingAddenda = getStartingAddenda(memberData);
    console.log('startingAddenda', startingAddenda)

    const allCampaignAddenda = (memberData?.__addenda__ || []).filter(a => a.key.startsWith('campaign:moments-2025:content:')).sort((a1, a2) => a1.key < a2.key ? -1 : 1)
    console.log('CTM2025 All Addenda', allCampaignAddenda)
    let currentCycle = 0;
    
    let relevantAddenda = [];
    if (startingAddenda.length > 0) {
        currentCycle = Math.floor(Math.max(...allCampaignAddenda.map(a => Number(a.key.split(':')[3]))) / 100);
        // const currentCycleEnd = getCycleEndTime(startingAddenda[0].data.ts);
        const nextCycleStartTime = getNextCycleStartTime(startingAddenda[0].data.ts);
        console.log(`currentCycle = ${currentCycle}`)
        console.log(`nextCycleStartTime = ${nextCycleStartTime}`)
        if (new Date() >= nextCycleStartTime) {
            relevantAddenda = [];
        } else {
            relevantAddenda = allCampaignAddenda.filter(a => Number(a.key.split(':')[3]) > currentCycle * 100);
        }
    }

    console.log('CTM2025 Relevant Addenda', relevantAddenda)
    const ctmTasksComplete = (() => {
        if (completeBasedOnRecentUpload) {
            return true;
        }
        if (relevantAddenda.length < 7) {
            return false;
        }
        for (let idx = 0; idx < relevantAddenda.length; idx++) {
            if (!relevantAddenda[idx].data.validated) {
                return false;
            }
        }
        return true;
    })()

    useEffect(() => {
        // Function to update the width
        const updateWidth = () => {
            if (containerRef.current) {
                setContainerWidth(containerRef.current.offsetWidth);
            }
        };

        updateWidth(); // Update width initially

        // Add event listener for window resize
        window.addEventListener('resize', updateWidth);

        return () => {
            // Cleanup event listener on component unmount
            window.removeEventListener('resize', updateWidth);
        };
    }, [showModal]);

    const fileInputRef = useRef(null);
    const fileChangeHandler = (event) => {
        setUploadInProgress(true);

        const imageUploadConfigSmall = {
            quality: 0.75,
            maxWidth: isDev ? 256 : 512,
            maxHeight: isDev ? 256 : 512,
            mimeType: 'image/png',
            debug: isDev,
        };
        
        const imageUploadConfigLarge = {
            quality: 0.8,
            maxWidth: 1024,
            maxHeight: 1024,
            mimeType: 'image/png',
            debug: isDev,
        };

        console.log('[ctm|image-selected]', event.target.files)
        if (event.target.files && event.target.files.length > 0) {
            Promise.all([
                readAndCompressImage(event.target.files[0], imageUploadConfigSmall),
                readAndCompressImage(event.target.files[0], imageUploadConfigLarge),
            ])
                .then(([resizedImageSmall, resizedImageLarge]) => {
                    console.log('[ctm|image-resize] resize->small', resizedImageSmall)
                    console.log('[ctm|image-resize] resize->large', resizedImageLarge)

                    const formData = new FormData();
                    formData.append('token', token);
                    formData.append('campaign', 'moments-2025');
                    formData.append('small', resizedImageSmall, `small-${event.target.files[0].name}.png`);
                    formData.append('large', resizedImageLarge, `large-${event.target.files[0].name}.png`);

                    RESTUtils.postMultipartFormData('/promotions/upload-member-content', formData, { method: 'POST' })
                        .then(r => {
                            const clearPopUpLater = () => setTimeout(() => {
                                setShowPopupType(null);
                            }, CTM_POPUP_DURATION_IN_MS)

                            if (!!r?.data?.success) {
                                if (!!r?.data?.data) {
                                    const addendaData = JSON.parse(r.data.data)
                                    console.log('Upload Member Content Result:', addendaData)
                                    if (!addendaData.validated) {
                                        setShowPopupType('TRANSACTION_NEEDED')
                                    } else {
                                        const candidateImageCode = `UPLOAD_VALIDATED_${addendaData.img_idx}`
                                        if (addendaData.img_idx >= 7) {
                                            if (!!CTM_POPUP_FILENAMES[candidateImageCode]) {
                                                setShowPopupType(candidateImageCode)
                                            } else {
                                                setShowPopupType('COMPLETED')
                                            }
                                            setCompleteBasedOnRecentUpload(true)
                                        } else {
                                            if (!!CTM_POPUP_FILENAMES[candidateImageCode]) {
                                                setShowPopupType(candidateImageCode)
                                            } else {
                                                setShowPopupType('UPLOAD_VALIDATED')
                                            }
                                        }
                                    }
                                    clearPopUpLater()
                                }
                            } else {
                                if (r?.data?.has_validated_addenda_today) {
                                    setShowPopupType('DECLINED')
                                    clearPopUpLater()
                                }
                            }
                        })
                        .catch(() => {
                            // do nothing
                        })
                        .then(() => {
                            return updateMemberData();
                        })
                        .catch(() => {
                            // do nothing
                        })
                        .then(() => {
                            setUploadInProgress(false);
                        });
                })
        }
    }

    return (
        <Modal
            show={showModal}
            fullscreen={true}
        >
            <Modal.Body
                className='promo-modal-body'
            >
                <div style={{
                    position:'absolute', zIndex: '50',
                    top: '1em', left: '0px', 
                    width: 'calc(100% - 1em)',
                    height: '3em',
                    textAlign: 'right',
                }}>
                    <CloseButton
                        variant={CLOSE_BUTTON_VARIANT}
                        onClick={() => setShowModal(false)}
                    />
                </div>

                {/* <input
                    ref={fileInputRef}
                    onChange={fileChangeHandler}
                    style={{ display: 'none' }}
                    type="file" accept="image/*" capture="camera"
                /> */}

                <input
                    ref={fileInputRef}
                    onChange={fileChangeHandler}
                    style={{ display: 'none' }}
                    type="file" accept="capture=camera,image/*"
                />

                <div ref={containerRef} style={{
                    width: 'calc(100% + calc(2*var(--bs-modal-padding))',
                    height: `${CTM_MAIN_HEIGHT * scaleFactor}px`,
                    margin: 'calc(-1*var(--bs-modal-padding))',
                    position: 'relative',
                }}>
                    <img
                        onClick={() => {
                            // setFrontBackToggle(cv => !cv)
                            if (isDev && ctmTasksComplete && containerRef.current) {
                                html2canvas(containerRef.current, { useCORS: true })
                                    .then(canvas => {
                                        const parentEl = containerRef.current;

                                        const data = canvas.toDataURL('image/jpg');
                                        const link = document.createElement('a');
                                    
                                        link.href = data;
                                        link.download = 'downloaded.jpg';
                                        link.style.display = 'none';
                                        link.text = 'data';
                                        link.style.zIndex = 0;
                                    
                                        parentEl.appendChild(link);
                                        link.click();
                                        parentEl.removeChild(link);
                                    })
                            }
                        }}
                        src={CTM_MAIN_IMAGE_FILENAME + CACHE_BREAKER_IN_DEV} alt="CTM Main"
                        style={{
                            position: 'relative',
                            width: '100%',
                            // zIndex: frontBackToggle ? 10 : 40,
                            zIndex: 40,
                        }}
                    />

                    {
                        !!showPopupType && CTM_POPUP_FILENAMES[showPopupType] && (
                            <>
                                <img
                                    src={CTM_POPUP_FILENAMES[showPopupType] + CACHE_BREAKER_IN_DEV} alt={`Status Popup: ${showPopupType}`}
                                    style={{
                                        zIndex: 60,
                                        width: '80%',
                                        height: 'auto',
                                        maxHeight: '70vh',
                                        position: 'fixed',
                                        top: '15vh',
                                        left: '11%',
                                    }}
                                    onClick={() => setShowPopupType(null)}
                                />
                            </>
                        )
                    }

                    {
                        !ctmTasksComplete && (
                            <img
                                onClick={() => {
                                    if (!uploadInProgress && fileInputRef.current) {
                                        fileInputRef.current.click();
                                    }
                                }}
                                src={CTM_UPLOAD_BUTTON_IMAGE_FILENAME + CACHE_BREAKER_IN_DEV} alt='CTM Upload Button'
                                style={{
                                    zIndex: 50,
                                    width: `${Math.ceil(CTM_UPLOAD_BUTTON_WIDTH * scaleFactor)}px`,
                                    height: `${Math.ceil(CTM_UPLOAD_BUTTON_HEIGHT * scaleFactor)}px`,
                                    position: 'absolute',
                                    top: `${CTM_UPLOAD_BUTTON_Y_POS * scaleFactor}px`,
                                    left: `${CTM_UPLOAD_BUTTON_X_POS * scaleFactor}px`,
                                    filter: `grayscale(${uploadInProgress ? '100%' : '0%'})`,
                                }}
                            />
                        )
                    }

                    {
                        relevantAddenda.map((a, idx) => {
                            return (
                                <img
                                    key={a.key}
                                    src={`${a.data.img_small.url}?ts=${a?.ts?.getTime && a.ts.getTime() || 0}`}
                                    alt={`Member Moment ${a.data.img_idx}`}
                                    style={{
                                        zIndex: CTM_SLOTS[idx].zIndex,
                                        objectFit: 'cover',  // crop!!!
                                        width: `${Math.ceil(CTM_SLOT_WIDTH * scaleFactor)}px`,
                                        height: `${Math.ceil(CTM_SLOT_WIDTH * scaleFactor)}px`,
                                        position: 'absolute',
                                        top: `${CTM_SLOTS[idx].y * scaleFactor}px`,
                                        left: `${CTM_SLOTS[idx].x * scaleFactor}px`,
                                        transform: `rotate(${CTM_SLOTS[idx].rot}deg)`,
                                        transformOrigin: 'top left',
                                        filter: `grayscale(${a.data.validated ? 0 : '95%'})`,
                                    }}
                                />
                            )
                        })
                    }

                    <img
                        src={CTM_BG_IMAGE_FILENAME + CACHE_BREAKER_IN_DEV} alt="CTM BG"
                        style={{
                            width: '100%',
                            height: 'auto',
                            zIndex: 0,
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                        }}
                    />

                </div>

                {/* Because we have two negative margins */}
                <VerticalSeparator height='calc(2*var(--bs-modal-padding))'/>
                
                <div style={{
                    width: 'calc(100% + calc(2*var(--bs-modal-padding))',
                    height: 'auto',
                    margin: 'calc(-1*var(--bs-modal-padding))',
                    position: 'relative',
                }}>
                    <img
                        src={(ctmTasksComplete ? CTM_COMPLETE_FOOTER_FILENAME : CTM_ONGOING_FOOTER_ONGOING_FILENAME) + CACHE_BREAKER_IN_DEV} alt="CTM Footer"
                        style={{
                            width: '100%',
                            zIndex: 10,
                        }}
                    />

                    {
                        !ctmTasksComplete && (
                            <a href={CTM_TERMS_AND_CONDITIONS_URL} target='_blank' rel='noreferrer'>
                                <img
                                    src={CTM_TERMS_AND_CONDITIONS_FILENAME + CACHE_BREAKER_IN_DEV} alt="CTM T&C Link"
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                        zIndex: 10,
                                        position: 'absolute',
                                        top: `${CTM_TERMS_AND_CONDITIONS_Y_POS * scaleFactor}px`,
                                        left: '0px',
                                    }}
                                />
                            </a>
                        )
                    }
                </div>

                {/* <VerticalSeparator height='calc(var(--bs-modal-padding))'/> */}
            </Modal.Body>
        </Modal>
    )
}

CaptureTheMoments.__heading__ = 'Capture the Moments';
CaptureTheMoments.__imgSrc__ = PROMO_IMAGE;
CaptureTheMoments.__onlyShowImage__ = true;
// CaptureTheMoments.__display_start_date__ = isDev ? new Date('2024-01-01') : new Date('2024-02-19');
CaptureTheMoments.__start_date__ = new Date('2025-01-20T00:00:00+08:00');
CaptureTheMoments.__end_date__ = new Date('2025-04-30');
CaptureTheMoments.__end_time__ = new Date('2025-04-30T23:59:59+08:00');
// CaptureTheMoments.__override_condition__ = () => isDev && (new Date() < new Date(CaptureTheMoments.__end_date__.getTime() + (1000 * 60 * 60 * 24)));
CaptureTheMoments.__additional_condition__ = (memberData) => {
    // Cycle Check
    const startingAddenda = getStartingAddenda(memberData);
    if (startingAddenda.length === 0) {
        // Participation Check
        console.log('[CTM2025] No starting addenda found, not displaying')
        return false;
    } else {
        const endTime = getCycleEndTime(startingAddenda[0].data.ts)
        const nextCycleStartTime = getNextCycleStartTime(startingAddenda[0].data.ts)
        console.log(`[CTM2025] ${startingAddenda.length} addenda items.\nCycle end time: ${endTime}\nNext cycle start time: ${nextCycleStartTime}`)
        if (new Date() <= endTime) {
            console.log(`[CTM2025] In current cycle`)
            return true;
        } else if (new Date() >= nextCycleStartTime) {
            console.log(`[CTM2025] Able to start next cycle`)
            return true;
        } else {
            console.log(`[CTM2025] Post Cycle, pending start of next`)
            return false;
        }
    }
}
CaptureTheMoments.__below_button_text__ = (memberData) => {
    const startingAddenda = getStartingAddenda(memberData);
    if (startingAddenda.length > 0) {
        const cycleEndTime = getCycleEndTime(startingAddenda[0].data.ts)
        const nextCycleStartTime = getNextCycleStartTime(startingAddenda[0].data.ts)
        const campaignEndTime = CaptureTheMoments.__end_time__;
        if ((cycleEndTime > new Date()) && (campaignEndTime > new Date())) {
            return `Open for Participation till ${moment(new Date(Math.min(cycleEndTime, campaignEndTime))).format('DD MMMM YYYY')}`;
        } else if (new Date() >= nextCycleStartTime) {
            return;
        } else {
            return `Closed for Participation after ${moment(cycleEndTime).format('DD MMMM YYYY')}`;
        }
    }
}

CaptureTheMoments.__additional_styles__ = {
    // border: '4px solid gold',
    // marginLeft: '-4px',
    // marginRight: '-4px',
    // border: '4px solid var(--swensens-brand-color)',
    // backgroundColor: 'goldenrod',
};
